import { render, staticRenderFns } from "./page-sleep-stories.vue?vue&type=template&id=79996b7f&scoped=true&"
import script from "./page-sleep-stories.vue?vue&type=script&lang=ts&"
export * from "./page-sleep-stories.vue?vue&type=script&lang=ts&"
import style0 from "./page-sleep-stories.vue?vue&type=style&index=0&id=79996b7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79996b7f",
  null
  
)

export default component.exports